module.exports = __webpack_public_path__ + "img/bg_lottery_luck_mall.4b245df4.png";